import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useDashboardNotifications } from "../../context/DashboardNotificationsContext";
import NotificationCard from "./NotificationCard";

const NotificationFeed = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const { cards } = useDashboardNotifications();

  return (
    <Box sx={{ width: 340, maxHeight: 440, overflowY: "auto", p: 1.5 }}>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 700, mb: 1, px: 0.5, color: isDark ? "#e2e8f0" : "#1e293b" }}
      >
        Announcements
      </Typography>
      {cards.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
            py: 4,
            color: isDark ? "rgba(255,255,255,0.5)" : "#94a3b8",
          }}
        >
          <CheckCircleOutlineIcon fontSize="large" />
          <Typography variant="body2">You're all caught up</Typography>
        </Box>
      ) : (
        cards.map((message) => (
          <NotificationCard key={message.id} message={message} />
        ))
      )}
    </Box>
  );
};

export default NotificationFeed;
